import styled, { css } from 'styled-components';
import { darken, readableColor, saturate } from 'polished';

const StyledButton = styled.button`
  -webkit-appearance: none;
  display: block;
  height: ${({ fullHeight }) => (fullHeight ? '100%' : '40px')};
  width: ${({ fullWidth }) => fullWidth && '100%'};
  min-width: ${({ minWidth }) => minWidth || '121px'};
  margin-top: ${({ noTopMargin }) => noTopMargin || '10px'};
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  background: #fff;
  color: #333;
  border: ${({ border, theme }) =>
    border || `2px solid ${theme.buttonBorder || '#333'}`};

  color: ${props => props.color};

  ${({ background, color, border, fontSize, theme }) =>
    background ||
    color ||
    border ||
    (fontSize &&
      css`
        background: ${background};
        color: ${color || '#333'};
        border: ${border || `2px solid ${theme.buttonBorder || '#333'}`};
        font-size: ${fontSize || '16px'};
      `)};

  ${({ primary, theme }) =>
    primary &&
    css`
      background: ${theme.buttonPrimary};
      color: #fff;
      border: 0;
    `};

  ${({ disabled, theme }) =>
    disabled &&
    css`
      background: ${theme.disabledColor};
      color: #fff;
      border: 0;
    `};

  color: ${({ color }) => color || color};
  background: ${({ background }) => background || background};

  font-size: ${({ fontSize, theme }) =>
    fontSize || theme.buttonFontSize || '16px'};
  font-weight: bold;
  line-height: 23px;
  outline: 0;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }

  &:hover {
    background-color: ${({ theme, background, disabled }) =>
      !disabled && saturate(0.25, background || theme.buttonPrimary)};
    color: ${({ theme, background, disabled }) =>
      !disabled &&
      readableColor(saturate(0.25, background || theme.buttonPrimary))};
  }

  &:focus {
    outline: thin solid
      ${({ theme, background }) =>
        darken(0.05, background || theme.buttonPrimary)};
    color: ${({ theme, background }) =>
      readableColor(background || theme.buttonPrimary)};
    border: ${({ primary }) => (primary ? 'thin solid white' : null)};
    background: ${({ theme, background }) =>
      saturate(0.15, background || theme.buttonPrimary)};
  }

  &:active {
    background-color: ${({ theme, background }) =>
      darken(0.01, background || theme.buttonPrimary)};
    box-shadow: none;
    color: ${({ theme, background }) =>
      readableColor(darken(0.01, background || theme.buttonPrimary))};
  }

  transition: outline 0.1s linear, color 150ms linear;
`;

export default StyledButton;
